import { PrintQueueMaintenanceConstant } from "presentation/constant/PrintQueue/PrintQueueMaintenanceConstant";
import { usePrintQueueMaintenanceVM } from "presentation/hook/PrintQueue/usePrintQueueMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { usePrintQueueMaintenanceTracked } from "presentation/store/PrintQueue/PrintQueueMaintenanceProvider";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const PrintQueueEditPanelTitleBar: React.FC = () => {
    const [printQueueState] = usePrintQueueMaintenanceTracked();
    const printQueueVM = usePrintQueueMaintenanceVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState, seqPrintLabel } = printQueueState;
    const { editingEntity, isAdd, isEditable, isRead } = masterState;

    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowUpdate } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isRead ? currentSelectedRow : editingEntity;

    const handleReset = useCallback(async () => {
        printQueueVM.onReset();
    }, [printQueueVM]);

    const handleEdit = useCallback(() => {
        printQueueVM.onEdit(currentEntity);
    }, [currentEntity, printQueueVM])

    const handleSave = useCallback(async () => {
        if (currentEntity.enabledSeqLabel === 'Y' && currentEntity.sequentialPrintingLabel === null) {
            if (!seqPrintLabel?.some(x => x.value)) {
                messageBarVM.showError('Maximum number of print queue for sequential printing are assigned.');
                return;
            }
            currentEntity.sequentialPrintingLabel = seqPrintLabel.filter(x => x.value)[0]?.key;
        }
        if (currentEntity.enabledSeqLabel === 'N') {
            currentEntity.sequentialPrintingLabel = null;
        }
        setIsLoading(true);
        try {
            printQueueVM.onSaveClicked();
            const res = await printQueueVM.onSave(currentEntity, isAdd);
            if (!!!res || !res.success) {
                res?.data && messageBarVM.showError(res?.data ?? 'Save data failed.');
            } else {
                printQueueVM.onSearch().then((data) => {
                    messageBarVM.showSuccess("Save Successfully.");
                    setIsLoading(false)
                }).catch(error => {
                    setIsLoading(false)
                });
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, isAdd, messageBarVM, printQueueVM, seqPrintLabel]);

    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: PrintQueueMaintenanceConstant.CATEGORY },
            { title: PrintQueueMaintenanceConstant.TITLE }]} onCurrentClick={() => { }}>
            </HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {(!isAdd && (!isEditable && isRead)) &&
                <>
                    {/* Edit Button */}
                    {
                        (
                            (!isEditable && allowUpdate)
                        )
                        && <IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                    }
                    {/* Close Button */}
                    <IconButton fileName='Icon-cross' size='medium' toolTipText={'Close'} toolTipArrow={false} onClick={printQueueVM.onClose} />
                </>}
            {(isAdd || (isEditable && !isRead)) &&
                <>
                    {/* Reset Form Button */}
                    <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />
                    {/* Save Button */}
                    {
                        (
                            (isAdd && allowCreate) ||
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName="Icon-tick" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                    }
                    {/* Close Button */}
                    <IconButton fileName="Icon-cross" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={printQueueVM.onClose} />
                </>}
        </StyledAction>
    </Sidebarheader>
}

export default memo(PrintQueueEditPanelTitleBar);